import React from 'react';
import { iconSizer } from "../../../../../icons2022/iconSizer";
import { PdfIcon16Solid } from "../../../../../icons2022/FileTypePdfIcon/PdfIcon16Solid";
import { PdfIcon20Solid } from "../../../../../icons2022/FileTypePdfIcon/PdfIcon20Solid";
import { PdfIcon24Solid } from "../../../../../icons2022/FileTypePdfIcon/PdfIcon24Solid";
export var PdfIcon = iconSizer({
  small: function small() {
    return /*#__PURE__*/React.createElement(PdfIcon16Solid, null);
  },
  medium: function medium() {
    return /*#__PURE__*/React.createElement(PdfIcon20Solid, null);
  },
  large: function large() {
    return /*#__PURE__*/React.createElement(PdfIcon24Solid, null);
  }
}, 'PdfIcon');